import { createTheme } from "@mui/material";

declare module "@mui/material/styles/createPalette" {
  interface PaletteOptions {
    [key: string]: string;
  }
}

const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiSkeleton: {
      defaultProps: {
        animation: "wave",
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Noto Sans KR",
        },
      },
    },
  },
  palette: {
    white: "#ffffff",
    black: "#000000",
    darkGrey: "rgb(131, 123, 123)",
    lightGrey: "#f6f6f6",
    brownishGrey: "#666666",
    dividerGrey: "#d8d8d8",
  },
});

export default theme;
